import React,{useState} from 'react'
import "./GalleryGrid.css"
import ImgModal from "../ImgModal/ImgModal"


const gallVideosUrl = [
    {
        src:"/images/Gallery/Videos/vid-1.mp4",
        poster:null
    }
    ,
    {
        src:"/images/Gallery/Videos/vid-2.mp4",
        poster:"/images/Gallery/Videos/vid-2-poster.png"
    }
]



function GalleryGrid({
    heading="Photo Gallery",
    gallImgUrl,
    toggleModal,
    showVideosOnly=false
}) {

    
    
  return (
    <div className={`GalleryGrid-container pt-5 ${showVideosOnly && "mb-5"} `}>
        
        <h3 className='body-heading text-center mx-auto mt-4'>{heading}</h3>

        <div className='container pt-5'>
            <div className='row gy-4'>
                {
                    !showVideosOnly && 
                    gallImgUrl.map((ele)=>{
                        return(
                        <div className='col-xl-4'>
                            <div 
                            className='img-card'
                             id={ele.source} 
                             onClick={(e)=>{toggleModal(e,false)}}
                             style={{backgroundImage:`url(${ele.source})`,backgroundPosition:`${ele.position?ele.position:"start"}`}}></div>
                        </div>
                        )
                    })
                }
                {
                    showVideosOnly &&
                    gallVideosUrl.map((ele)=>{
                        return(
                        <div className='col-xl-6 d-flex ' >
                            <video className='img-card mx-auto'
                            poster={ele?.poster}
                            style={{width:"fit-content",maxWidth:"100%",background:'black'}}
                             id={ele.src} 
                             onClick={(e)=>{toggleModal(e,ele.src)}}
                             src={ele.src}></video>
                        </div>
                        )
                    })
                }
            </div>
        </div>
    </div>
  )
}

export default GalleryGrid